import { useIsMobile } from "../volleyball/context/mobileContext";
import NFLDesktopDashboard from "./screens/NFLDesktopDashboard";
import NFLMobileDashboard from "./screens/NFLMobileDashboard";

const NFLDashboard = () => {
  const isMobile = useIsMobile();
  return isMobile ? <NFLMobileDashboard /> : <NFLDesktopDashboard />;
};

export default NFLDashboard;
